import { Injectable, OnDestroy } from '@angular/core';
import { PurchasesService } from 'src/app/@pages/purchases/purchases.service';
import { Subject, firstValueFrom } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IRefunds } from 'src/app/@interfaces/refunds.interface';
import { TranslateService } from '@ngx-translate/core';
import { AlertsService } from '../../../services/alerts/alerts.service';
import { IPurchasePayments } from 'src/app/@interfaces/payments.interface';
import { PortfolioService } from 'src/app/@pages/portfolio/portfolio.service';

@Injectable({
  providedIn: 'root',
})
export class PayPurchaseService implements OnDestroy {
  unsubscribe$ = new Subject<void>();
  constructor(
    private purchasesService: PurchasesService,
    private translate: TranslateService,
    private alertsService: AlertsService,
    private portfolioService: PortfolioService,
  ) {}

  getPurchasePayments(id_invoice: number): Promise<IPurchasePayments[]> {
    return firstValueFrom(
      this.portfolioService
        .getPaymenPurchase(id_invoice)
        .pipe(takeUntil(this.unsubscribe$)),
    );
  }

  getInvoice(id_invoice: number) {
    return firstValueFrom(
      this.purchasesService
        .getPurchaseInvoice(id_invoice)
        .pipe(takeUntil(this.unsubscribe$)),
    );
  }

  async getRefunds(id_invoice: number): Promise<number> {
    const result = await firstValueFrom(
      this.purchasesService
        .getRefundsByPurchaseID(id_invoice)
        .pipe(takeUntil(this.unsubscribe$)),
    );
    return this.sumRefunds(result as IRefunds[]);
  }

  async getInvoiceWithRefunds(id_invoice: number) {
    const { invoice, refunds } = await firstValueFrom(
      this.purchasesService
        .getPurchaseInvoiceWithRefunds(id_invoice)
        .pipe(takeUntil(this.unsubscribe$)),
    );
    return { invoice, refundsTotal: this.sumRefunds(refunds as IRefunds[]) };
  }

  private sumRefunds(refunds: IRefunds[]): number {
    return refunds.reduce((total, r) => total + r.total * -1, 0);
  }

  validations(value: number, missingPaid: number) {
    if (value > parseFloat(missingPaid.toFixed(2))) {
      this.alertsService.showErrorAlert(
        `${this.translate.instant(
          'You cannot make a payment greater than the amount due!',
        )} ($${parseFloat(missingPaid.toFixed(2)).toFixed(2)})`,
      );
      return false;
    } else {
      return true;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
